import { AnimatePresence } from "framer-motion";
import ReactDOM from "react-dom/client";

import { BrowserRouter, Route, Routes } from "react-router-dom";

import Transitions from "utils/transition";

//New Imports
import { CardTitle } from "components/card/card_title/card_title.js";
import { CardTitlePasserCommande } from "components/card/card_title/passer_commande/passer_commande";
import { CardHolder } from "components/card_holder/card_holder.js";
import { Carousel } from "components/carousel/carousel.js";
import { Footer } from "components/footer/footer.js";
import "components/general/background.css";
import "components/general/clean.css";
import "components/general/colors.css";
import "components/general/positions.css";
import "components/general/sizes.css";
import { Map } from "components/map/map";
import { NavigationBarHeader } from "components/navbar/navbar_pizza.js";
import Pin from "images/pin.svg";
import Leaflet from "leaflet";
import { Loading } from "pages/loading/loading.js";
import { Modif } from "pages/modif/modif.js";
import { Nouveautes } from "pages/nouveautes/nouveautes";
import { PizzasDesserts } from "pages/pizzas desserts/pizzas_desserts";
import { Pizzas } from "pages/pizzas/pizzas.js";
import { Marker } from "react-leaflet";
import { filterMainPagePizzas } from "utils/filters/filterMainPagePizzas";
import { filterPizzaNouveaute } from "utils/filters/filterPizzaNouveaute";
import { useStrapi } from "hooks/use-strapi.ts";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AnimatePresence exitBeforeEnter>
    <BrowserRouter>
      <Routes>
        <Route key="1" path="/" element={<Index />} />
        <Route key="2" path="pizzas" element={<Pizzas />} />
        <Route key="3" path="pizzas_desserts" element={<PizzasDesserts />} />
        <Route key="4" path="nouveautes" element={<Nouveautes />} />
        <Route key="5" path="modif" element={<Modif />} />
      </Routes>
    </BrowserRouter>
  </AnimatePresence>,
);

function Index() {
  const { data: etablissement, loading: loadingEtablissement } =
    useStrapi("cg-etablissement");
  const { data: pizzasBasique, loading: loadingPizzaBasique } =
    useStrapi("cg-pizza-basiques");
  const { data: PizzaClassique, loading: loadingPizzaClassique } = useStrapi(
    "cg-pizza-classiques",
  );
  const { data: pizzasGourmande, loading: loadingPizzaGourmande } = useStrapi(
    "cg-pizza-gourmandes",
  );
  const { data: pizzasDessert, loading: loadingPizzaDessert } =
    useStrapi("cg-pizza-desserts");
  const { data: parameters, loading: loadingParameters } = useStrapi(
    "cg-parametres-du-site",
  );

  if (
    loadingEtablissement ||
    loadingPizzaBasique ||
    loadingPizzaClassique ||
    loadingPizzaGourmande ||
    loadingParameters ||
    loadingPizzaDessert
  ) {
    return <Loading />;
  }

  let allPizzas = [];
  allPizzas = allPizzas.concat(pizzasBasique);
  allPizzas = allPizzas.concat(PizzaClassique);
  allPizzas = allPizzas.concat(pizzasGourmande);
  allPizzas = allPizzas.concat(pizzasDessert);

  let pizzasMainPage = filterMainPagePizzas(allPizzas);
  let pizzasNouveaute = filterPizzaNouveaute(allPizzas);

  let pizzaMomentUrl;
  if (pizzasNouveaute.length !== 0) {
    pizzaMomentUrl =
      pizzasNouveaute[getRandomInt(pizzasNouveaute.length - 1)]?.Photo;
  }

  let interval =
    parameters.Temps_Pour_Changer_Photo_Pizza_Accueil_En_Secondes * 1000;
  let transitionTime =
    parameters.Temps_Pour_Realiser_Transition_Accueil_En_Secondes * 1000;

  let center = {
    lat: etablissement.Latitude,
    lng: etablissement.Longitude,
  };

  let zoomInput = 15;

  let pinIcon = Leaflet.icon({
    iconUrl: Pin,
    iconRetinaUrl: Pin,
    iconAnchor: [5, 55],
    popupAnchor: [10, -44],
    iconSize: [50, 50],
  });

  return (
    <>
      <Transitions>
        <NavigationBarHeader />
        <Carousel
          urlImages={pizzasMainPage}
          timeToChangeMs={interval}
          transitionTimeMs={transitionTime}
        />
        <CardHolder>
          <CardTitle title="Où sommes nous">
            <Map zoom={zoomInput} center={center}>
              <Marker
                position={[etablissement.Latitude, etablissement.Longitude]}
                icon={pinIcon}
              ></Marker>
            </Map>
          </CardTitle>
          <CardTitlePasserCommande
            pizzas={pizzasMainPage}
            etablissement={etablissement}
            showOpening={true}
            imageContact={pizzaMomentUrl}
          />
        </CardHolder>
        <Footer
          adress={etablissement.Adresse}
          contact={etablissement.Telephone}
        />
      </Transitions>
    </>
  );
}

function getRandomInt(max) {
  return Math.floor(Math.random() * max);
}
